import { Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTriangleExclamation,
  faCircleExclamation,
  faCircleInfo,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

const SEVERITY = {
  CRITICAL: { icon: faCircleExclamation, cls: 'danger', label: 'Critical' },
  WARNING: { icon: faTriangleExclamation, cls: 'warning', label: 'Warning' },
  INFO: { icon: faCircleInfo, cls: 'info', label: 'Info' }
};

const since = ts => {
  if (!ts) return '';
  const mins = Math.max(0, Math.round((Date.now() - Number(ts)) / 60000));
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  return h < 24 ? `${h}h` : `${Math.round(h / 24)}d`;
};

/**
 * One condition, not one occurrence. `firstSeenAt` is when the problem started,
 * which is the number that matters — an alert open for three hours reads very
 * differently from one that just appeared, even though both are "current".
 */
const AlertItem = ({ alert, onAck, compact = false }) => {
  const s = SEVERITY[alert.severity] || SEVERITY.INFO;
  const acked = alert.status === 'ACKNOWLEDGED';

  return (
    <div className={`d-flex gap-2 px-3 py-2 ${acked ? 'opacity-75' : ''}`}>
      <FontAwesomeIcon icon={s.icon} className={`text-${s.cls} mt-1`} />

      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="fw-semibold fs-9 text-900">{alert.title}</span>
          {acked ? (
            <Badge
              bg="secondary"
              className="fs-10"
              title={`Acknowledged by ${alert.acknowledgedBy || 'someone'}`}
            >
              acknowledged
            </Badge>
          ) : null}
        </div>

        <div className="fs-10 text-700">{alert.detail}</div>

        <div className="fs-10 text-600 mt-1">
          {/* how long the problem has been going on, not when we last looked */}
          open for {since(alert.firstSeenAt)}
          {alert.occurrences > 1 ? ` · seen ${alert.occurrences}×` : ''}
          {!compact && alert.firstSeenAt
            ? ` · since ${dayjs(alert.firstSeenAt).format('DD MMM, HH:mm')}`
            : ''}
        </div>
      </div>

      {onAck && !acked ? (
        <Button
          size="sm"
          variant="link"
          className="p-0 text-700 align-self-start"
          title="I know about this — it stays open until the machine recovers"
          onClick={() => onAck(alert)}
        >
          <FontAwesomeIcon icon={faCheck} />
        </Button>
      ) : null}
    </div>
  );
};

export default AlertItem;
